/** Normalize IP for display (strip IPv4-mapped IPv6 prefix, etc.). */
export function formatDisplayIp(ip?: string | null): string {
  if (!ip || !ip.trim()) return '—'
  const trimmed = ip.trim()
  if (trimmed === '::1' || trimmed === '::ffff:127.0.0.1') {
    return '127.0.0.1'
  }
  const ipv4Mapped = trimmed.match(/^::ffff:(\d+\.\d+\.\d+\.\d+)$/i)
  if (ipv4Mapped) {
    return ipv4Mapped[1]
  }
  return trimmed
}
